module.exports = __webpack_public_path__ + "img/kdLogo_ZH.8d594394.svg";